<template>
  <div v-if="loading" class="text-center font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" />
  </div>
  <div v-else class="animated">
    <div>
      <b-row class="mb-3 font-weight-bolder">
        <b-col class="font-weight-bolder">
          Name
        </b-col>
        <b-col v-if="sample" md="2" class="text-right">
          Results
        </b-col>
        <b-col v-if="sample" md="2" class="text-right">
          Approved
        </b-col>
        <b-col md="2" class="text-right">
          Actions
        </b-col>
      </b-row>

      <b-row v-for="(item, index) in existing_analytes" :key="index + 'existing'" class="mb-3">
        <b-col>{{ item.analyte.name }}</b-col>

        <b-col md="2" class="text-right">
          <i v-if="item.results" class="far fa-check-square" />
          <i v-else class="far fa-square" />
        </b-col>

        <b-col md="2" class="text-right">
          <i v-if="item.approved" class="far fa-check-square" />
          <i v-else class="far fa-square" />
        </b-col>

        <b-col md="2" class="text-right">
          <b-form-checkbox
            v-model="item.delete"
            name="check-button"
            button
            :button-variant="item.delete ? 'danger' : ''"
            size="sm"
          >
            <i v-if="item.delete" class="far fa-check-square" />
            <i v-else class="far fa-square" />
            <span class="ml-2">Delete</span>
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row v-for="(item, index) in new_analytes" :key="index + 'new'" class="mb-3">
        <b-col>
          <multiselect
            v-model="item.analyte"
            :options="analyte_options"
            :multiple="false"
            track-by="id"
            label="name"
          />
        </b-col>
        <b-col v-if="sample" md="2" class="text-right" />
        <b-col v-if="sample" md="2" class="text-right" />
        <b-col md="2" class="text-right">
          <b-button
            variant="danger"
            size="sm"
            @click="removeRow(index)"
          >
            <i class="fa fa-trash" />
            <span class="ml-2">Delete</span>
          </b-button>
        </b-col>
      </b-row>
    </div>

    <b-button block variant="success" :disabled="!analyte_options.length" @click="addRow">
      <i class="fa fa-plus" />
      Add
    </b-button>
  </div>
</template>

<script>
import { getCollection } from '@/shared/fetch-utils'
import Multiselect from 'vue-multiselect'

export default {
  name: 'SampleFormAnalytes',
  components: {
    Multiselect
  },
  props: {
    analytes: {
      type: Array,
      default: () => []
    },
    sample_type: {
      type: Object,
      default: () => {}
    },
    sample: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      loading: true,
      existing_analytes: [],
      new_analytes: [],
      analyte_collection: null,
      analyte_options: [],
      analyte_result: null
    }
  },
  computed: {},
  watch: {
    analytes: {
      handler () {
        this.initExistingAnalytes()
      },
      deep: true
    },
    sample_type: {
      handler (newVal, oldVal) {
        if ((!oldVal && newVal.id) || (oldVal && newVal.id !== oldVal.id)) {
          this.fetchAnalytes()
        }
      },
      immediate: true,
      deep: true
    },
    existing_analytes: {
      handler () {
        this.$emit('existingAnalytesUpdated', this.existing_analytes)
      },
      immediate: true,
      deep: true
    },
    new_analytes: {
      handler () {
        this.$emit('newAnalytesUpdated', this.new_analytes)
      },
      immediate: true,
      deep: true
    }
  },
  async created () {
    this.loading = true

    if (this.sample && this.sample.id) {
      this.analyte_result = await getCollection({
        collection_type: 'analyte_result',
        filters: [
          {
            logic: 'filterEquals',
            field: 'sample_id',
            value: this.sample.id
          }
        ]
      })
      
      this.initExistingAnalytes()
    }

    this.loading = false
  },
  methods: {
    addRow () {
      this.new_analytes.push({ analyte: null })
    },
    removeRow (index) {
      this.new_analytes.splice(index, 1)
    },
    async fetchAnalytes () {
      this.analyte_collection = await getCollection({
        collection_type: 'analyte',
        filters: [
          {
            logic: 'filterEquals',
            field: 'sample_type_id',
            value: this.sample_type.id
          },
          {
            logic: 'filterNotNull',
            field: 'testPackageAnalytes.testPackageSample.testPackage.add_on',
            value: this.sample_type.id
          }
        ],
        sort: [
        {
          logic: "sortAddAsc",
          field: "name",
        }
      ],
        limit: 'all',
        message: this.$bvToast
      })

      this.analyte_options = this.analyte_collection.models.map((analyte) => {
        return {
          id: analyte.id,
          name: analyte.name
        }
      })
    },
    initExistingAnalytes () {
      this.existing_analytes = this.analytes.map((item) => {
        const sample_analyte_result = this.analyte_result ? this.analyte_result.models.find((result) => result.analyte_id === item.id) : null

        return {
          analyte: item,
          results: !!sample_analyte_result,
          approved: sample_analyte_result ? sample_analyte_result.current_analyte_result_status_log.analyte_result_status.status == 'Approved' : false,
          delete: false
        }
      })
    }
  }
}
</script>
